import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useAppSelector from 'hooks/useAppSelector';
import { Box, Divider, Link, Typography, useMediaQuery } from '@mui/material';
import theme from 'theme';
import Page from 'components/templates/Page';
import GoogleButton from 'components/atoms/GoogleButton';
import FacebookButton from 'components/atoms/FacebookButton';
import LinkedinButton from 'components/atoms/LinkedinButton';
import EmailForm from 'components/molecules/EmailForm';
import ScreenLoading from 'components/organisms/ScreenLoading';
import { useStyles } from './styles';
import { useError } from '../../context/ErrorContext';

function Authentication() {
  const styles = useStyles();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true
  });
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');
  const isCompany = action === 'job_open';

  const { isLoading, message } = useAppSelector((state) => state.helper);

  const [loading, setLoading] = useState(false);

  const { errorMessage } = useError();

  useEffect(() => {
    if (isLoading) {
      setLoading(true);
    }

    if (message) {
      setLoading(false);
    }
  }, [isLoading, message]);

  const title = <span>Acesse ou {isSmallScreen && <br />}crie sua conta</span>;

  const subtitle = (
    <span>
      Seus dados estão seguros e você
      <br /> não precisa de senha.
    </span>
  );

  if (loading) {
    return <ScreenLoading />;
  }

  return (
    <Page title={title} subtitle={subtitle}>
      <Box className={styles.container}>
        <Box className={styles.form}>
          <Box className={styles.socialNetwork}>
            {errorMessage && (
              <span className={styles.error}>{errorMessage}</span>
            )}
            <FacebookButton isCompany={isCompany} />
            <GoogleButton isCompany={isCompany} />
            <LinkedinButton isCompany={isCompany} />
          </Box>
          <Divider>
            <Typography className={styles.divider}>ou</Typography>
          </Divider>
          <EmailForm />
        </Box>
        <Box className={styles.margin} />
        <Typography className={styles.terms}>
          Ao continuar, você está de acordo com os <br />
          <Link
            href="https://app.gria.com.br/termos-uso-politica-privacidade"
            target="_blank"
            className={styles.link}
          >
            Termos de uso e política de Privacidade.
          </Link>
        </Typography>
      </Box>
    </Page>
  );
}

export default Authentication;
